<template>
 <div class="col-md-12" id="tree_">
   <!-- <h1>Tree Test D3.js</h1> -->
   <!-- <svg id="tree" :width="width" :height="height"></svg> -->
   <!-- <div v-for="(item, index) in data" :key="index">
     <img v-bind:src="item">
   </div> -->

   <!-- <div class="container-fluid">
     <div class="row">
     </div>
   </div> -->
 </div>
</template>

<script>
import * as d3 from "d3"
import db from "../firebase.js"
// import DATA from "./data.json";

const width = window.innerWidth;
const height = window.innerHeight;
// var width = document.querySelector("svg").clientWidth;
// var height = document.querySelector("svg").clientHeight;

function tree (data) {
  const root = d3.hierarchy(data);
  // compute the new height
  var levelWidth = [1];
  var childCount = function(level, n) {

    if(n.children && n.children.length > 0) {
      if(levelWidth.length <= level + 1) levelWidth.push(0);

      levelWidth[level+1] += n.children.length;
      n.children.forEach(function(d) {
        childCount(level + 1, d);
      });
    }
  };
  childCount(0, root);
  var max_depth = d3.max(levelWidth); // 20 pixels per line

  root.dx = 15;
  root.dy = width / (root.height+1);
  console.log("height: ", root.height)
  console.log("depth: ", root.depth)
  console.log("dx: ", root.dx)
  console.log("dy: ", root.dy)
  console.log("window-width: ", width)
  console.log("window-height: ", height)
  console.log("max depth: ", max_depth)

  const tree = d3.tree()
    .size([height, width])
    .nodeSize([root.dx, root.dy])(root)
  return tree;
};

function getTreeSVG(tree_data_){

  const root = tree(JSON.parse(tree_data_));
  var canvas = d3.select("#tree_");
  const svg = canvas.append("svg")
    .attr("preserveAspectRatio", "xMinYMin meet")
    .attr("width", width)
    .attr("height", height)
    .attr("viewBox", [0, 0, width, height])
      .classed("svg-content", true)

  // const svg = d3.create("svg")
  //   .attr('xmlns', 'http://www.w3.org/2000/svg')
  //   .attr("preserveAspectRatio", "xMinYMid meet")
  //   .attr("viewBox", [0, 0, width, height])
  //     .classed("svg-content", true)
  //     // .call(responsivefy);

  const g = svg
    .append("g")
    .attr("font-family", "sans-serif")
    .attr("font-size", 12)
    .attr("transform", `translate(${50}, ${height/2 - 50})`);

  const link = g
    .append("g")
    .attr("fill", "none")
    .attr("stroke", "#555")
    .attr("stroke-opacity", 0.4)
    .attr("stroke-width", 1.2)
    .selectAll("path")
    .data(root.links())
    .join("path")
    .attr(
      "d",
      d3
        .linkHorizontal()
        .x((d) => d.y)
        .y((d) => d.x)
    );

  const node = g
    .append("g")
    .attr("stroke-linejoin", "round")
    .attr("stroke-width", 3)
    .selectAll("g")
    .data(root.descendants())
    .join("g")
    .attr("transform", (d) => `translate(${d.y}, ${d.x})`)
    .on("click", (e, d) => clicked(d));

  node
    .append("image")
    .attr("xlink:href", (d) => d.data.icon)
    .attr("x", "-12px")
    .attr("y", "-19px")
    .attr("width", "24px")
    .attr("height", "24px")

  // node
  //   .append("text")
  //   .attr("x", -5)
  //   .attr("dy", "0.31em")
  //   .attr("text-anchor", "end")
  //   .text((d) => d.data.name)
  //   .clone(true)
  //   .lower()
  //   .attr("stroke", "white");

  node.append("circle").attr("fill", "#999").attr("r", 3);
  // node.forEach(function(d) { d.x = d.depth * 180; });

  const svgToDataURL = require('svg-to-dataurl')
  const dataUrl = svgToDataURL(svg.node().outerHTML)
  // document.getElementById("app").append(this.data);
  // var s = new XMLSerializer();

  // Normalize for fixed-depth.

  return dataUrl
}

async function getChildren (index_) {
  // const parent =
  var parent_;
  await db.collection("info")
    .where("index", "==", parseInt(index_))
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
        parent_ = doc.data()
      })
    })
  // console.log("parent: ", parent_)
  if (parent_ == null){
    return;
  }

  console.log("parent: ", index_)
  // console.log("children: ", parent_.children)

  let parent_obj = {"name": parent_.name }
  parent_obj.icon = parent_.image

  let n_children = parent_.children.length
  // console.log("children: ", n_children)
  let children = []

  for(let i=0; i<n_children; i++){
    let child_index = parent_.children[i]
    // console.log("child: ", child_index)
    // var child_obj = {"name": address};

    if (child_index != null){
      let tmp = await getChildren(child_index)
      if (tmp != null){
        children.push(tmp)
      }
    }
  }

  if (children.length > 0){
    parent_obj.children = children
  }

  // console.log(parent_obj)
  return parent_obj
}

export default {
 name: 'tree_',
 data() {
   return {
     data: [],
     tree_data: []
   }
 },
 components: {
 },
 mounted: async function () {

   // this.tree_data = JSON.stringify(await getChildren(1))
   // // console.log(this.tree_data)
   // let test = this.tree_data.match(/.{1,1000000}/g);
   // console.log("splitted: ", test[test.length-1])
   // // console.log(this.tree_data)

   await db.collection("tree_splitted")
     .orderBy('index')
     .get()
     .then((querySnapshot) => {
       querySnapshot.forEach((doc) => {
         this.tree_data.push(`${doc.data().split_data}`)
       })
     })

  console.log(this.tree_data.join(""))

   this.data.push(getTreeSVG(this.tree_data.join("")))
   // console.log(this.data)
   // document.getElementById("app").append(this.data);
 },
}
</script>



// WEBPACK FOOTER //
// src/components/TreeD3.vue